/**
 * @generated SignedSource<<761ee9a1e95f8062f380c36344b559db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type userNameColumn_Fragment$data = {
  readonly extension: {
    readonly firstName?: string | null | undefined;
    readonly lastName?: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "userNameColumn_Fragment";
};
export type userNameColumn_Fragment$key = {
  readonly " $data"?: userNameColumn_Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"userNameColumn_Fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "userNameColumn_Fragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "userExtensionKind",
          "value": "InfectopharmUserExtension"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "extension",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastName",
              "storageKey": null
            }
          ],
          "type": "InfectopharmUserExtension",
          "abstractKey": null
        }
      ],
      "storageKey": "extension(userExtensionKind:\"InfectopharmUserExtension\")"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "54d4bcede69fb413dd9b3ba224b1053b";

export default node;
